import { render, staticRenderFns } from "./ManifestbyInstructorView.vue?vue&type=template&id=1c1b38b3&"
import script from "./ManifestbyInstructorView.vue?vue&type=script&lang=js&"
export * from "./ManifestbyInstructorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c1b38b3')) {
      api.createRecord('1c1b38b3', component.options)
    } else {
      api.reload('1c1b38b3', component.options)
    }
    module.hot.accept("./ManifestbyInstructorView.vue?vue&type=template&id=1c1b38b3&", function () {
      api.rerender('1c1b38b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ManifestbyInstructorView.vue"
export default component.exports